import styled from 'styled-components';

export default styled.div`

    width: 100%;

    .modal {
        .content {
            text-align: left;
        }
    }

    .wrapper {
        
        .box {
            display: flex;
            flex-direction: column;
            margin-right: 30px;
            width: 270px;
            height: 220px;
            .bottomSection {
               margin-top: auto;
            }
            .icon {
                position: relative;
                top: -1px;
            }
        }

    }

`
